import { gql } from '@apollo/client';

export const DELETE_NOTIFICATION_MUTATION = gql`
	mutation RemoveNotification($id: Int!) {
		removeNotification(id: $id) {
      id
		}
	}
`;